module.exports = __webpack_public_path__ + "img/sleeve_length.95420c2c.png";